export const blockIconsBusinessandpaymentsTrendingUpNew = (
	<span className='material-symbols-outlined'>trending_up</span>
);
